import * as React from 'react'
import {Dialog, styled} from '@mui/material'

type Props = {
  open: boolean
  onClose: (value: string) => void
  children?: React.ReactNode
}

const DialogCustomCss = styled(Dialog)(({theme}) => ({
  '& .MuiDialog-container': {
    alignItems: 'normal',
  },
  '& .MuiPaper-root': {
    position: 'inherit',
    maxHeight: 'inherit',
    maxWidth: 'inherit',
    backgroundColor: 'transparent',
    boxShadow: 'none',
    margin: '64px',
    width: '100%',
  },
}))

export const DialogCustom: React.FC<Props> = ({children, open, onClose}) => {
  const handleClose = () => {
    onClose('false')
  }

  return (
    <DialogCustomCss onClose={handleClose} open={open}>
      {children}
    </DialogCustomCss>
  )
}
